// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Youtube: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd">
                <rect width="31" height="31" x=".5" y=".5" stroke="#FFF" opacity=".33" />
                <path
                    fill="#FFF"
                    d="M14.4001465,18.6581196 L14.4001465,12.7403723 L18.9696572,15.6987664 L14.4001465,18.6581196 Z M24,12.849454 C24,11.5515006 22.9296883,10.5 21.6084575,10.5 L10.3915425,10.5 C9.07031167,10.5 8,11.5515006 8,12.849454 L8,19.1503062 C8,20.4477802 9.07031167,21.5 10.3915425,21.5 L21.6084575,21.5 C22.9296883,21.5 24,20.4477802 24,19.1503062 L24,12.849454 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Youtube);
